module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "usertype-edit"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/master"
    }
  }, [_vm._v(_vm._s(_vm.$t('Master Manage')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/user_types"
    }
  }, [_vm._v(_vm._s(_vm.$t('User Type List')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('User Type Edit')))])])]), _c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('User Type Edit')))]), (_vm.loading) ? _c('div', {
    staticClass: "row margin-top"
  }, [_vm._m(0)]) : _c('div', [(_vm.usertype != null && _vm.getQuestionEnd) ? _c('div', [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('usertype.list.Name')))]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usertype.data.attributes['user-type-name']),
      expression: "usertype.data.attributes['user-type-name']"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.user_type_name
    },
    attrs: {
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": _vm._s(_vm.usertype.data.attributes['user-type-name'])
    },
    on: {
      "keyup": _vm.half,
      "touchend": _vm.half,
      "change": _vm.half,
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.usertype.data.attributes,
          $$idx = 'user-type-name';
        if (!Array.isArray($$exp)) {
          _vm.usertype.data.attributes['user-type-name'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.user_type_name),
      expression: "!validation.user_type_name"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])]), _c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('usertype.list.Default')))]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usertype.data.attributes['default-user-authority']),
      expression: "usertype.data.attributes['default-user-authority']"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.default_user_authority
    },
    on: {
      "change": function($event) {
        var $$exp = _vm.usertype.data.attributes,
          $$idx = 'default-user-authority';
        if (!Array.isArray($$exp)) {
          _vm.usertype.data.attributes['default-user-authority'] = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          })[0]
        } else {
          $$exp.splice($$idx, 1, Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          })[0])
        }
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v(_vm._s(_vm.$t('usertype.type1')))]), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v(_vm._s(_vm.$t('usertype.type2')))]), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v(_vm._s(_vm.$t('usertype.type3')))]), _c('option', {
    domProps: {
      "value": 4
    }
  }, [_vm._v(_vm._s(_vm.$t('usertype.type4')))]), _c('option', {
    domProps: {
      "value": 5
    }
  }, [_vm._v(_vm._s(_vm.$t('usertype.type5')))])]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.default_user_authority),
      expression: "!validation.default_user_authority"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('usertype.list.Priority')))]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usertype.data.attributes['user-type-priority']),
      expression: "usertype.data.attributes['user-type-priority']"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.user_type_priority
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm._s(_vm.usertype.data.attributes['user-type-priority'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.usertype.data.attributes,
          $$idx = 'user-type-priority';
        if (!Array.isArray($$exp)) {
          _vm.usertype.data.attributes['user-type-priority'] = _vm._n($event.target.value)
        } else {
          $$exp.splice($$idx, 1, _vm._n($event.target.value))
        }
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.user_type_priority),
      expression: "!validation.user_type_priority"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])]), _c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('usertype.list.Employee')))]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usertype.data.attributes['employee-flg']),
      expression: "usertype.data.attributes['employee-flg']"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.employee_flg
    },
    on: {
      "change": function($event) {
        var $$exp = _vm.usertype.data.attributes,
          $$idx = 'employee-flg';
        if (!Array.isArray($$exp)) {
          _vm.usertype.data.attributes['employee-flg'] = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          })[0]
        } else {
          $$exp.splice($$idx, 1, Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          })[0])
        }
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v(_vm._s(_vm.$t('usertype.employee')))]), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v(_vm._s(_vm.$t('usertype.not_employee')))])]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.employee_flg),
      expression: "!validation.employee_flg"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('businesstype.list.Detail')))]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.businesstype.data.attributes['business-type-content']),
      expression: "businesstype.data.attributes['business-type-content']"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.business_type_content
    },
    attrs: {
      "maxlength": "255",
      "rows": "6"
    },
    domProps: {
      "value": _vm._s(_vm.businesstype.data.attributes['business-type-content'])
    },
    on: {
      "keyup": _vm.contentCounter,
      "touchend": _vm.contentCounter,
      "change": _vm.contentCounter,
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.businesstype.data.attributes,
          $$idx = 'business-type-content';
        if (!Array.isArray($$exp)) {
          _vm.businesstype.data.attributes['business-type-content'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.business_type_content),
      expression: "!validation.business_type_content"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.contentCount) + "/255")])]), _c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("評価")]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usertype.data.attributes['question-id']),
      expression: "usertype.data.attributes['question-id']"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$exp = _vm.usertype.data.attributes,
          $$idx = 'question-id';
        if (!Array.isArray($$exp)) {
          _vm.usertype.data.attributes['question-id'] = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          })[0]
        } else {
          $$exp.splice($$idx, 1, Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          })[0])
        }
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("設定なし")]), _vm._l((_vm.questions), function(question) {
    return _c('option', {
      domProps: {
        "value": question.id
      }
    }, [_vm._v(_vm._s(question.title))])
  })], 2)])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('a', {
    staticClass: "btn btn-info",
    class: {
      disabled: !_vm.validation.not_input
    },
    staticStyle: {
      "margin-right": "5px"
    },
    on: {
      "click": function($event) {
        _vm.onClickSave()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Save')))])]), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.onClickCancel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Cancel')))])])])])])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/loading.gif")
    }
  }), _c('p', [_vm._v("loading...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-916feeb6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/usertype-edit.pug
// module id = 895
// module chunks = 1